import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState, useCallback, useEffect } from 'react';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import createDebug from 'debug';
import Player from '@vimeo/player';
import { loadYouTube } from '@folklore/services';

var styles = {"videoContainer":"panneau-element-media-player-videoContainer","inner":"panneau-element-media-player-inner","overlay":"panneau-element-media-player-overlay","video":"panneau-element-media-player-video","loading":"panneau-element-media-player-loading","playIcon":"panneau-element-media-player-playIcon","muteIcon":"panneau-element-media-player-muteIcon","paused":"panneau-element-media-player-paused","muted":"panneau-element-media-player-muted","controls":"panneau-element-media-player-controls","audioContainer":"panneau-element-media-player-audioContainer","audio":"panneau-element-media-player-audio"};

var propTypes$2 = {
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool,
  loop: PropTypes.bool,
  media: PropTypes.shape({}),
  width: PropTypes.number,
  height: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  withoutControls: PropTypes.bool,
  className: PropTypes.string,
  audioClassName: PropTypes.string
};
var defaultProps$2 = {
  autoPlay: false,
  muted: false,
  loop: true,
  media: null,
  width: null,
  height: null,
  withoutControls: false,
  className: null,
  audioClassName: null
};
var Audio = function Audio(_ref) {
  var autoPlay = _ref.autoPlay,
    muted = _ref.muted,
    loop = _ref.loop,
    media = _ref.media,
    width = _ref.width,
    height = _ref.height,
    withoutControls = _ref.withoutControls,
    className = _ref.className,
    audioClassName = _ref.audioClassName;
  var _ref2 = media || {},
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url,
    _ref2$thumbnail_url = _ref2.thumbnail_url,
    thumbnail = _ref2$thumbnail_url === void 0 ? null : _ref2$thumbnail_url,
    _ref2$thumbnailUrl = _ref2.thumbnailUrl,
    thumbnailUrl = _ref2$thumbnailUrl === void 0 ? null : _ref2$thumbnailUrl,
    _ref2$provider = _ref2.provider,
    videoProvider = _ref2$provider === void 0 ? null : _ref2$provider;
  var el = useRef(null);
  var finalThumbnailUrl = thumbnail || thumbnailUrl || null;
  return /*#__PURE__*/React.createElement("div", {
    ref: el,
    className: classNames([styles.audioContainer, _defineProperty(_defineProperty({}, styles.isNative, videoProvider === null), className, className !== null)]),
    style: {
      backgroundImage: finalThumbnailUrl !== null ? "url(".concat(finalThumbnailUrl, ")") : null
    }
  }, url !== null ? /*#__PURE__*/React.createElement("audio", {
    key: media !== null ? "video-".concat(url) : 'video',
    className: classNames([styles.audio, _defineProperty({}, audioClassName, audioClassName !== null)]),
    src: url !== null ? url : null,
    type: "audio/mp3",
    style: {
      width: width,
      height: height
    },
    controls: !withoutControls,
    loop: loop,
    autoPlay: autoPlay,
    muted: muted
  }) : null);
};
Audio.propTypes = propTypes$2;
Audio.defaultProps = defaultProps$2;
var Audio$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Audio, Object.assign({
    apiRef: ref
  }, props));
});

var debug$2 = createDebug('video:native');
var noPlayerError$2 = new Error('No player');
var useNativeVideo = function useNativeVideo(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0 : _ref$duration,
    _ref$initialMuted = _ref.initialMuted,
    initialMuted = _ref$initialMuted === void 0 ? true : _ref$initialMuted,
    _ref$onLoaded = _ref.onLoaded,
    customOnLoaded = _ref$onLoaded === void 0 ? null : _ref$onLoaded,
    _ref$onPlay = _ref.onPlay,
    customOnPlay = _ref$onPlay === void 0 ? null : _ref$onPlay,
    _ref$onPause = _ref.onPause,
    customOnPause = _ref$onPause === void 0 ? null : _ref$onPause,
    _ref$onEnd = _ref.onEnd,
    customOnEnd = _ref$onEnd === void 0 ? null : _ref$onEnd,
    _ref$onMetadataChange = _ref.onMetadataChange,
    customOnMetadataChange = _ref$onMetadataChange === void 0 ? null : _ref$onMetadataChange,
    _ref$onVolumeChange = _ref.onVolumeChange,
    customOnVolumeChange = _ref$onVolumeChange === void 0 ? null : _ref$onVolumeChange,
    _ref$onBufferStart = _ref.onBufferStart,
    customOnBufferStart = _ref$onBufferStart === void 0 ? null : _ref$onBufferStart,
    _ref$onBufferEnded = _ref.onBufferEnded,
    customOnBufferEnded = _ref$onBufferEnded === void 0 ? null : _ref$onBufferEnded,
    _ref$onTimeUpdate = _ref.onTimeUpdate,
    customOnTimeUpdate = _ref$onTimeUpdate === void 0 ? null : _ref$onTimeUpdate;
  var playerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    ready = _useState2[0],
    setReady = _useState2[1];
  var _useState3 = useState(initialMuted),
    _useState4 = _slicedToArray(_useState3, 2),
    muted = _useState4[0],
    setMuted = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentTime = _useState6[0],
    setCurrentTime = _useState6[1];
  var _useState7 = useState({
      playing: false,
      paused: false,
      ended: false,
      buffering: false
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    playState = _useState8[0],
    setPlayState = _useState8[1];
  var _useState9 = useState({
      width: width,
      height: height,
      duration: duration
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    metadata = _useState10[0],
    setMetadata = _useState10[1];
  var realCurrentTime = useRef(currentTime);
  var play = useCallback(function () {
    var player = playerRef.current;
    return player !== null && typeof player.play !== 'undefined' ? Promise.resolve(player.play()) : Promise.reject(noPlayerError$2);
  }, []);
  var pause = useCallback(function () {
    var player = playerRef.current;
    return player !== null && typeof player.pause !== 'undefined' ? Promise.resolve(player.pause()) : Promise.reject(noPlayerError$2);
  }, []);
  var setVolume = useCallback(function (volume) {
    var player = playerRef.current;
    var promise = player !== null && typeof player.volume !== 'undefined' ? Promise.resolve(function () {
      player.volume = volume * 100;
    }) : Promise.reject(noPlayerError$2);
    if (customOnVolumeChange) {
      customOnVolumeChange(volume);
    }
    return promise;
  }, [customOnVolumeChange]);
  var mute = useCallback(function () {
    var player = playerRef.current;
    return (player !== null && typeof player.volume !== 'undefined' ? Promise.resolve(function () {
      player.volume = 0;
    }) : Promise.reject(noPlayerError$2)).then(function () {
      return setMuted(true);
    });
  }, [setMuted]);
  var unmute = useCallback(function () {
    var player = playerRef.current;
    return (player !== null && typeof player.volume !== 'undefined' ? Promise.resolve(function () {
      player.volume = 1;
    }) : Promise.reject(noPlayerError$2)).then(function () {
      return setMuted(false);
    });
  }, []);
  var seek = useCallback(function (time) {
    var player = playerRef.current;
    return player !== null && typeof player.currentTime !== 'undefined' ? Promise.resolve(function () {
      player.currentTime = time;
    }) : Promise.reject(noPlayerError$2);
  }, []);
  var setLoop = useCallback(function (loop) {
    var player = playerRef.current;
    return player !== null && typeof player.loop !== 'undefined' ? Promise.resolve(function () {
      player.loop = loop;
    }) : Promise.reject(noPlayerError$2);
  }, []);
  var destroyPlayer = useCallback(function () {
    var player = playerRef.current;
    if (player !== null) {
      debug$2('Unset player');
      playerRef.current = null;
    }
  }, []);

  // Create player
  useEffect(function () {}, [setPlayState, setReady, setMetadata, destroyPlayer]);
  var playing = playState.playing,
    paused = playState.paused,
    buffering = playState.buffering,
    ended = playState.ended;
  useEffect(function () {
    if (ready && customOnLoaded !== null) {
      customOnLoaded();
    }
  }, [ready, customOnLoaded]);
  useEffect(function () {
    if (playing && customOnPlay !== null) {
      customOnPlay();
    }
  }, [playing, customOnPlay]);
  useEffect(function () {
    if (paused && customOnPause !== null) {
      customOnPause();
    }
  }, [paused, customOnPause]);
  useEffect(function () {
    if (buffering && customOnBufferStart !== null) {
      customOnBufferStart();
    } else if (!buffering && customOnBufferEnded !== null) {
      customOnBufferEnded();
    }
  }, [buffering, customOnBufferStart, customOnBufferEnded]);
  useEffect(function () {
    if (ended && customOnEnd !== null) {
      customOnEnd();
    }
  }, [ended, customOnEnd]);
  useEffect(function () {
    if (muted && playerRef.current !== null) {
      playerRef.current.muted = muted;
      playerRef.current.defaultMuted = muted;
    }
  }, [muted, playerRef.current]);
  useEffect(function () {
    if (autoplay && playerRef.current !== null) {
      playerRef.current.play();
    }
  }, [autoplay, playerRef.current]);
  var metaWidth = metadata.width,
    metaHeight = metadata.height,
    metaDuration = metadata.duration;
  useEffect(function () {
    if (metadata && customOnMetadataChange !== null) {
      customOnMetadataChange({
        width: metaWidth,
        height: metaHeight,
        duration: metaDuration
      });
    }
  }, [metaWidth, metaHeight, metaDuration, customOnMetadataChange]);

  // Check time update
  useEffect(function () {
    var player = playerRef.current;
    if (player === null) {
      return function () {};
    }
    var onTimeUpdate = function onTimeUpdate() {
      var seconds = player.getCurrentTime();
      realCurrentTime.current = seconds;
      setCurrentTime(seconds);
      if (customOnTimeUpdate !== null) {
        customOnTimeUpdate(seconds);
      }
    };
    var interval = null;
    if (playing) {
      interval = setInterval(onTimeUpdate, 1000);
    }
    return function () {
      if (interval !== null) {
        clearInterval(interval);
      }
    };
  }, [setCurrentTime, playing]);
  return _objectSpread(_objectSpread({
    ref: playerRef,
    play: play,
    pause: pause,
    mute: mute,
    unmute: unmute,
    setVolume: setVolume,
    seek: seek,
    setLoop: setLoop,
    ready: ready,
    currentTime: realCurrentTime.current,
    muted: muted,
    loaded: ready
  }, metadata), playState);
};

var debug$1 = createDebug('video:vimeo');
var isVideoId$1 = function isVideoId(url) {
  return url !== null && url.match(/^[0-9]+$/);
};
var getVideoId$1 = function getVideoId(url) {
  if (url === null) {
    return null;
  }
  if (isVideoId$1(url)) {
    return url;
  }
  var match = url.match(/\/[0-9]+/);
  return match !== null ? match[1] : null;
};
var noPlayerError$1 = new Error('No player');
var useVimeo = function useVimeo(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$videoId = _ref.videoId,
    initialVideoId = _ref$videoId === void 0 ? null : _ref$videoId,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0 : _ref$duration,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    _ref$autopause = _ref.autopause,
    autopause = _ref$autopause === void 0 ? true : _ref$autopause,
    _ref$byline = _ref.byline,
    byline = _ref$byline === void 0 ? false : _ref$byline,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? false : _ref$controls,
    _ref$initialMuted = _ref.initialMuted,
    initialMuted = _ref$initialMuted === void 0 ? false : _ref$initialMuted,
    _ref$onPlay = _ref.onPlay,
    customOnPlay = _ref$onPlay === void 0 ? null : _ref$onPlay,
    _ref$onPause = _ref.onPause,
    customOnPause = _ref$onPause === void 0 ? null : _ref$onPause,
    _ref$onEnd = _ref.onEnd,
    customOnEnd = _ref$onEnd === void 0 ? null : _ref$onEnd,
    _ref$onMetadataChange = _ref.onMetadataChange,
    customOnMetadataChange = _ref$onMetadataChange === void 0 ? null : _ref$onMetadataChange,
    _ref$onVolumeChange = _ref.onVolumeChange,
    customOnVolumeChange = _ref$onVolumeChange === void 0 ? null : _ref$onVolumeChange,
    _ref$onBufferStart = _ref.onBufferStart,
    customOnBufferStart = _ref$onBufferStart === void 0 ? null : _ref$onBufferStart,
    _ref$onBufferEnded = _ref.onBufferEnded,
    customOnBufferEnded = _ref$onBufferEnded === void 0 ? null : _ref$onBufferEnded,
    _ref$onTimeUpdate = _ref.onTimeUpdate,
    customOnTimeUpdate = _ref$onTimeUpdate === void 0 ? null : _ref$onTimeUpdate,
    _ref$onLoaded = _ref.onLoaded,
    customOnLoaded = _ref$onLoaded === void 0 ? null : _ref$onLoaded;
  var iframeRef = useRef(null);
  var playerRef = useRef(null);
  var videoId = initialVideoId || getVideoId$1(url);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    ready = _useState2[0],
    setReady = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var _useState5 = useState(initialMuted ? 0 : 1),
    _useState6 = _slicedToArray(_useState5, 2),
    volume = _useState6[0],
    setVolumeState = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    currentTime = _useState8[0],
    setCurrentTime = _useState8[1];
  var _useState9 = useState({
      playing: false,
      paused: false,
      ended: false,
      buffering: false
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    playState = _useState10[0],
    setPlayState = _useState10[1];
  var _useState11 = useState({
      width: width,
      height: height,
      duration: duration
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    metadata = _useState12[0],
    setMetadata = _useState12[1];
  var realCurrentTime = useRef(currentTime);
  var lastVideoId = useRef(videoId);
  var videoIdChanged = lastVideoId.current !== videoId;
  if (videoIdChanged) {
    realCurrentTime.current = 0;
    lastVideoId.current = videoId;
  }
  var play = useCallback(function () {
    var player = playerRef.current;
    return player !== null ? player.play() : Promise.reject(noPlayerError$1);
  }, []);
  var pause = useCallback(function () {
    var player = playerRef.current;
    return player !== null ? player.pause() : Promise.reject(noPlayerError$1);
  }, []);
  var setVolume = useCallback(function (newVolume) {
    var player = playerRef.current;
    return player !== null ? player.setVolume(newVolume) : Promise.reject(noPlayerError$1);
  }, []);
  var mute = useCallback(function () {
    var player = playerRef.current;
    return player !== null ? player.setVolume(0) : Promise.reject(noPlayerError$1);
  }, []);
  var unmute = useCallback(function () {
    var player = playerRef.current;
    return player !== null ? player.setVolume(1) : Promise.reject(noPlayerError$1);
  }, []);
  var seek = useCallback(function (time) {
    var player = playerRef.current;
    return player !== null ? player.setCurrentTime(time) : Promise.reject(noPlayerError$1);
  }, []);
  var setLoop = useCallback(function (loop) {
    var player = playerRef.current;
    return player !== null ? player.setLoop(loop) : Promise.reject(noPlayerError$1);
  }, []);
  var destroyVideo = useCallback(function () {
    var player = playerRef.current;
    if (player !== null) {
      debug$1('Unload video');
      player.unload();
    }
    if (player !== null) {
      debug$1('Unset video');
      playerRef.current = null;
    }
  }, []);
  var playerIframeRef = useRef(iframeRef.current);
  useEffect(function () {
    var currentPlayer = playerRef.current;
    if (playerIframeRef.current !== iframeRef.current && currentPlayer !== null) {
      debug$1('iFrame switched');
      destroyVideo();
    }
  });

  // Create player
  useEffect(function () {
    var currentPlayer = playerRef.current;
    if (videoId === null) {
      destroyVideo();
      return function () {};
    }
    var canceled = false;
    var player = currentPlayer;
    if (player === null) {
      debug$1('Create player [ID: %s]', videoId);
      var iframe = iframeRef.current;
      player = new Player(iframe, {
        id: videoId,
        autoplay: autoplay,
        autopause: autopause,
        byline: byline,
        controls: controls,
        muted: initialMuted,
        background: !controls
      });
      player.ready().then(function () {
        return setReady(true);
      })["catch"](function (e) {
        debug$1('ERROR: %o', e);
      });
      playerIframeRef.current = iframe;
    } else {
      debug$1('Load video [ID: %s]', videoId);
      player.loadVideo(videoId)["catch"](function (e) {
        debug$1('ERROR: %o', e);
      });
    }
    var onLoaded = function onLoaded() {
      Promise.all([player.getDuration(), player.getVideoWidth(), player.getVideoHeight(), player.getMuted()]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 4),
          newDuration = _ref3[0],
          newWidth = _ref3[1],
          newHeight = _ref3[2],
          newMuted = _ref3[3];
        var newMetadata = {
          duration: newDuration,
          width: newWidth,
          height: newHeight
        };
        setMetadata(newMetadata);
        if (newMuted) {
          setVolumeState(0);
        }
        setLoaded(true);
      });
      debug$1('onLoaded [ID: %s]', videoId);
    };
    var onPlay = function onPlay() {
      setPlayState({
        playing: true,
        paused: false,
        ended: false,
        buffering: false
      });
      debug$1('onPlay [ID: %s]', videoId);
      player.getMuted().then(function (newMuted) {
        if (!canceled && newMuted) {
          setVolumeState(0);
        }
      })["catch"](function () {});
    };
    var onPause = function onPause() {
      setPlayState({
        playing: false,
        paused: true,
        ended: false,
        buffering: false
      });
      debug$1('onPause [ID: %s]', videoId);
    };
    var onTimeUpdate = function onTimeUpdate(_ref4) {
      var seconds = _ref4.seconds;
      realCurrentTime.current = seconds;
      setCurrentTime(seconds);
      if (customOnTimeUpdate !== null) {
        customOnTimeUpdate(seconds);
      }
    };
    var onVolumeChange = function onVolumeChange(_ref5) {
      var newVolume = _ref5.volume;
      return setVolumeState(newVolume);
    };
    var onEnded = function onEnded() {
      return setPlayState({
        playing: false,
        paused: false,
        ended: true,
        buffering: false
      });
    };
    var onBufferStart = function onBufferStart() {
      setPlayState({
        playing: true,
        paused: false,
        ended: false,
        buffering: true
      });
      debug$1('onBufferStart [ID: %s]', videoId);
    };
    var onBufferEnded = function onBufferEnded() {
      setPlayState({
        playing: true,
        paused: false,
        ended: false,
        buffering: false
      });
      debug$1('onBufferStart [ID: %s]', videoId);
    };
    debug$1('Bind events [ID: %s]', videoId);
    player.on('loaded', onLoaded);
    player.on('play', onPlay);
    player.on('pause', onPause);
    player.on('timeupdate', onTimeUpdate);
    player.on('volumechange', onVolumeChange);
    player.on('ended', onEnded);
    player.on('bufferstart', onBufferStart);
    player.on('bufferend', onBufferEnded);
    playerRef.current = player;
    return function () {
      canceled = true;
      debug$1('Unbind events [ID: %s]', videoId);
      player.off('loaded', onLoaded);
      player.off('play', onPlay);
      player.off('pause', onPause);
      player.off('timeupdate', onTimeUpdate);
      player.off('volumechange', onVolumeChange);
      player.off('ended', onEnded);
      player.off('bufferstart', onBufferStart);
      player.off('bufferend', onBufferEnded);
    };
  }, [videoId, setReady, setPlayState, setMetadata, setVolumeState, destroyVideo, setLoaded, setCurrentTime]);
  var playing = playState.playing,
    paused = playState.paused,
    buffering = playState.buffering,
    ended = playState.ended;
  useEffect(function () {
    if (loaded && customOnLoaded !== null) {
      customOnLoaded();
    }
  }, [loaded, customOnLoaded]);
  useEffect(function () {
    if (customOnVolumeChange !== null) {
      customOnVolumeChange(volume);
    }
  }, [volume, customOnVolumeChange]);
  useEffect(function () {
    if (playing && customOnPlay !== null) {
      customOnPlay();
    }
  }, [playing, customOnPlay]);
  useEffect(function () {
    if (paused && customOnPause !== null) {
      customOnPause();
    }
  }, [paused, customOnPause]);
  useEffect(function () {
    if (buffering && customOnBufferStart !== null) {
      customOnBufferStart();
    } else if (!buffering && customOnBufferEnded !== null) {
      customOnBufferEnded();
    }
  }, [buffering, customOnBufferStart, customOnBufferEnded]);
  useEffect(function () {
    if (ended && customOnEnd !== null) {
      customOnEnd();
    }
  }, [ended, customOnEnd]);
  var metaWidth = metadata.width,
    metaHeight = metadata.height,
    metaDuration = metadata.duration;
  useEffect(function () {
    if (metadata && customOnMetadataChange !== null) {
      customOnMetadataChange({
        width: metaWidth,
        height: metaHeight,
        duration: metaDuration
      });
    }
  }, [metaWidth, metaHeight, metaDuration, customOnMetadataChange]);
  return _objectSpread(_objectSpread({
    ref: iframeRef,
    play: play,
    pause: pause,
    mute: mute,
    unmute: unmute,
    setVolume: setVolume,
    seek: seek,
    setLoop: setLoop,
    ready: ready,
    buffering: buffering,
    currentTime: realCurrentTime.current,
    loaded: loaded,
    muted: volume === 0
  }, metadata), playState);
};

var getYoutubeVideoId = function getYoutubeVideoId(url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
};
var debug = createDebug('video:youtube');
var isVideoId = function isVideoId(url) {
  return url !== null && url.match(/^https?:/) === null;
};
var getVideoId = function getVideoId(url) {
  if (url === null) {
    return null;
  }
  if (isVideoId(url)) {
    return url;
  }
  return getYoutubeVideoId(url);
};
var noPlayerError = new Error('No player');
var useYouTube = function useYouTube(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$videoId = _ref.videoId,
    initialVideoId = _ref$videoId === void 0 ? null : _ref$videoId,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0 : _ref$duration,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? 0 : _ref$controls,
    _ref$muted = _ref.muted,
    initialMuted = _ref$muted === void 0 ? false : _ref$muted,
    _ref$onLoaded = _ref.onLoaded,
    customOnLoaded = _ref$onLoaded === void 0 ? null : _ref$onLoaded,
    _ref$onPlay = _ref.onPlay,
    customOnPlay = _ref$onPlay === void 0 ? null : _ref$onPlay,
    _ref$onPause = _ref.onPause,
    customOnPause = _ref$onPause === void 0 ? null : _ref$onPause,
    _ref$onEnd = _ref.onEnd,
    customOnEnd = _ref$onEnd === void 0 ? null : _ref$onEnd,
    _ref$onMetadataChange = _ref.onMetadataChange,
    customOnMetadataChange = _ref$onMetadataChange === void 0 ? null : _ref$onMetadataChange,
    _ref$onVolumeChange = _ref.onVolumeChange,
    customOnVolumeChange = _ref$onVolumeChange === void 0 ? null : _ref$onVolumeChange,
    _ref$onBufferStart = _ref.onBufferStart,
    customOnBufferStart = _ref$onBufferStart === void 0 ? null : _ref$onBufferStart,
    _ref$onBufferEnded = _ref.onBufferEnded,
    customOnBufferEnded = _ref$onBufferEnded === void 0 ? null : _ref$onBufferEnded,
    _ref$onTimeUpdate = _ref.onTimeUpdate,
    customOnTimeUpdate = _ref$onTimeUpdate === void 0 ? null : _ref$onTimeUpdate;
  var iframeRef = useRef(null);
  var playerRef = useRef(null);
  var playerIframeRef = useRef(iframeRef.current);
  var _useState = useState(typeof window.YT !== 'undefined'),
    _useState2 = _slicedToArray(_useState, 2),
    apiReady = _useState2[0],
    setApiReady = _useState2[1];
  var videoId = initialVideoId || getVideoId(url);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    ready = _useState4[0],
    setReady = _useState4[1];
  var _useState5 = useState(initialMuted),
    _useState6 = _slicedToArray(_useState5, 2),
    muted = _useState6[0],
    setMuted = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    currentTime = _useState8[0],
    setCurrentTime = _useState8[1];
  var _useState9 = useState({
      playing: false,
      paused: false,
      ended: false,
      buffering: false
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    playState = _useState10[0],
    setPlayState = _useState10[1];
  var _useState11 = useState({
      width: width,
      height: height,
      duration: duration
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    metadata = _useState12[0],
    setMetadata = _useState12[1];
  var realCurrentTime = useRef(currentTime);
  var lastVideoId = useRef(videoId);
  var videoIdChanged = lastVideoId.current !== videoId;
  if (videoIdChanged) {
    realCurrentTime.current = 0;
    lastVideoId.current = videoId;
  }
  var play = useCallback(function () {
    var player = playerRef.current;
    return player !== null && typeof player.playVideo !== 'undefined' ? Promise.resolve(player.playVideo()) : Promise.reject(noPlayerError);
  }, []);
  var pause = useCallback(function () {
    var player = playerRef.current;
    return player !== null && typeof player.pauseVideo !== 'undefined' ? Promise.resolve(player.pauseVideo()) : Promise.reject(noPlayerError);
  }, []);
  var setVolume = useCallback(function (volume) {
    var player = playerRef.current;
    var promise = player !== null && typeof player.setVolume !== 'undefined' ? Promise.resolve(player.setVolume(volume * 100)) : Promise.reject(noPlayerError);
    if (customOnVolumeChange) {
      customOnVolumeChange(volume);
    }
    return promise;
  }, [customOnVolumeChange]);
  var mute = useCallback(function () {
    var player = playerRef.current;
    return (player !== null && typeof player.mute !== 'undefined' ? Promise.resolve(player.mute()) : Promise.reject(noPlayerError)).then(function () {
      return setMuted(true);
    });
  }, [setMuted]);
  var unmute = useCallback(function () {
    var player = playerRef.current;
    return (player !== null && typeof player.unMute !== 'undefined' ? Promise.resolve(player.unMute()) : Promise.reject(noPlayerError)).then(function () {
      return setMuted(false);
    });
  }, []);
  var seek = useCallback(function (time) {
    var player = playerRef.current;
    return player !== null && typeof player.seekTo !== 'undefined' ? Promise.resolve(player.seekTo(time)) : Promise.reject(noPlayerError);
  }, []);
  var setLoop = useCallback(function (loop) {
    var player = playerRef.current;
    return player !== null && typeof player.setLoop !== 'undefined' ? Promise.resolve(player.setLoop(loop)) : Promise.reject(noPlayerError);
  }, []);
  var destroyPlayer = useCallback(function () {
    if (playerRef.current !== null) {
      debug('Unset player');
      playerRef.current = null;
    }
  }, []);
  useEffect(function () {
    var canceled = false;
    if (!apiReady && videoId !== null) {
      loadYouTube().then(function () {
        if (!canceled) {
          setApiReady(true);
        }
      });
    }
    return function () {
      canceled = true;
    };
  }, [apiReady, videoId, setApiReady]);

  // Detect iframe switch and destroy player

  useEffect(function () {
    var currentPlayer = playerRef.current;
    if (playerIframeRef.current !== iframeRef.current && currentPlayer !== null) {
      debug('iFrame switched');
      destroyPlayer();
    }
  });

  // Create player
  useEffect(function () {
    var currentPlayer = playerRef.current;
    if (videoId === null || !apiReady) {
      destroyPlayer();
      return function () {};
    }
    var player = currentPlayer;
    if (player === null && iframeRef.current !== null) {
      debug('Create player [ID: %s]', videoId);
      var iframe = iframeRef.current;
      var onReady = function onReady(_ref2) {
        var target = _ref2.target;
        player = target;
        playerRef.current = target;
        setReady(true);
        var newDuration = target.getDuration();
        if (newDuration !== metadata.duration) {
          setMetadata(_objectSpread(_objectSpread({}, metadata), {}, {
            duration: newDuration
          }));
        }

        // if (initialMuted) {
        //     target.mute();
        // }
        //
        // if (autoplay) {
        //     target.playVideo();
        // }

        debug('onReady [ID: %s]', videoId);
      };
      var onStateChange = function onStateChange(_ref3) {
        var target = _ref3.target,
          state = _ref3.data;
        var newState = {
          playing: state === window.YT.PlayerState.PLAYING,
          paused: state === window.YT.PlayerState.PAUSED,
          ended: state === window.YT.PlayerState.ENDED,
          buffering: state === window.YT.PlayerState.BUFFERING
        };
        setPlayState(newState);
        var stateLabel = null;
        if (newState.playing) {
          stateLabel = 'playing';
        } else if (newState.paused) {
          stateLabel = 'paused';
        } else if (newState.ended) {
          stateLabel = 'ended';
        } else if (newState.buffering) {
          stateLabel = 'buffering';
        } else if (state === -1) {
          stateLabel = 'not started';
        } else if (state === 0) {
          stateLabel = 'stopped';
        }
        var id = typeof target.getVideoUrl !== 'undefined' ? getVideoId(target.getVideoUrl()) : videoId;
        debug('onStateChange %s [ID: %s]', stateLabel, id);
      };
      player = new window.YT.Player(iframe, {
        videoId: videoId,
        playerVars: {
          controls: controls,
          autoplay: autoplay ? 1 : 0,
          mute: initialMuted,
          playsinline: true,
          rel: 0,
          showinfo: 0,
          modestbranding: 1
        },
        events: {
          onReady: onReady,
          onStateChange: onStateChange
        }
      });
      playerIframeRef.current = iframe;
    } else {
      debug('Switch video [ID: %s]', videoId);
      player.loadVideoById(videoId);
    }
    playerRef.current = player;
  }, [apiReady, videoId, setPlayState, setReady, setMetadata, destroyPlayer]);
  var playing = playState.playing,
    paused = playState.paused,
    buffering = playState.buffering,
    ended = playState.ended;
  useEffect(function () {
    if (ready && videoId !== null && customOnLoaded !== null) {
      customOnLoaded();
    }
  }, [videoId, ready, customOnLoaded]);
  useEffect(function () {
    if (playing && customOnPlay !== null) {
      customOnPlay();
    }
  }, [playing, customOnPlay]);
  useEffect(function () {
    if (paused && customOnPause !== null) {
      customOnPause();
    }
  }, [paused, customOnPause]);
  useEffect(function () {
    if (buffering && customOnBufferStart !== null) {
      customOnBufferStart();
    } else if (!buffering && customOnBufferEnded !== null) {
      customOnBufferEnded();
    }
  }, [buffering, customOnBufferStart, customOnBufferEnded]);
  useEffect(function () {
    if (ended && customOnEnd !== null) {
      customOnEnd();
    }
  }, [ended, customOnEnd]);
  var metaWidth = metadata.width,
    metaHeight = metadata.height,
    metaDuration = metadata.duration;
  useEffect(function () {
    if (metadata && customOnMetadataChange !== null) {
      customOnMetadataChange({
        width: metaWidth,
        height: metaHeight,
        duration: metaDuration
      });
    }
  }, [metaWidth, metaHeight, metaDuration, customOnMetadataChange]);

  // Check time update
  useEffect(function () {
    var player = playerRef.current;
    if (player === null) {
      return function () {};
    }
    var onTimeUpdate = function onTimeUpdate() {
      var seconds = player.getCurrentTime();
      realCurrentTime.current = seconds;
      setCurrentTime(seconds);
      if (customOnTimeUpdate !== null) {
        customOnTimeUpdate(seconds);
      }
    };
    var interval = null;
    if (playing) {
      interval = setInterval(onTimeUpdate, 1000);
    }
    return function () {
      if (interval !== null) {
        clearInterval(interval);
      }
    };
  }, [setCurrentTime, playing]);
  return _objectSpread(_objectSpread({
    ref: iframeRef,
    play: play,
    pause: pause,
    mute: mute,
    unmute: unmute,
    setVolume: setVolume,
    seek: seek,
    setLoop: setLoop,
    ready: ready,
    currentTime: realCurrentTime.current,
    muted: muted,
    loaded: ready
  }, metadata), playState);
};

var _excluded$2 = ["type"];
var useVideo = function useVideo(url, _ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? null : _ref$type,
    opts = _objectWithoutProperties(_ref, _excluded$2);
  var vimeo = useVimeo(type === 'vimeo' ? url : null, type === 'vimeo' ? opts : {});
  var youtube = useYouTube(type === 'youtube' ? url : null, type === 'youtube' ? opts : {});
  var _native = useNativeVideo(type === null ? url : null, type === null ? opts : {});
  return _objectSpread(_objectSpread(_objectSpread({}, type === 'vimeo' ? vimeo : null), type === 'youtube' ? youtube : null), type === null ? _native : null);
};

var _excluded$1 = ["ref"];
var propTypes$1 = {
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  initialMuted: PropTypes.bool,
  media: PropTypes.shape({}),
  width: PropTypes.number,
  height: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  apiRef: PropTypes.any,
  withoutControls: PropTypes.bool,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onEnd: PropTypes.func,
  onMetadataChange: PropTypes.func,
  onVolumeChange: PropTypes.func,
  onBufferStart: PropTypes.func,
  onBufferEnded: PropTypes.func,
  onTimeUpdate: PropTypes.func,
  onLoaded: PropTypes.func,
  playsInline: PropTypes.bool,
  className: PropTypes.string,
  iframeClassName: PropTypes.string,
  videoClassName: PropTypes.string
};
var defaultProps$1 = {
  autoPlay: true,
  loop: true,
  initialMuted: true,
  media: null,
  width: null,
  height: null,
  apiRef: null,
  withoutControls: false,
  onPlay: null,
  onPause: null,
  onEnd: null,
  onMetadataChange: null,
  onVolumeChange: null,
  onBufferStart: null,
  onBufferEnded: null,
  onTimeUpdate: null,
  onLoaded: null,
  playsInline: null,
  className: null,
  iframeClassName: null,
  videoClassName: null
};
var Video = function Video(_ref) {
  var autoPlay = _ref.autoPlay,
    loop = _ref.loop,
    initialMuted = _ref.initialMuted,
    media = _ref.media,
    width = _ref.width,
    height = _ref.height,
    apiRef = _ref.apiRef,
    withoutControls = _ref.withoutControls,
    onPlay = _ref.onPlay,
    onPause = _ref.onPause,
    onEnd = _ref.onEnd,
    onMetadataChange = _ref.onMetadataChange,
    onVolumeChange = _ref.onVolumeChange,
    onBufferStart = _ref.onBufferStart,
    onBufferEnded = _ref.onBufferEnded,
    onTimeUpdate = _ref.onTimeUpdate,
    onLoaded = _ref.onLoaded,
    playsInline = _ref.playsInline,
    className = _ref.className,
    iframeClassName = _ref.iframeClassName,
    videoClassName = _ref.videoClassName;
  var _ref2 = media || {},
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url,
    _ref2$iframeUrl = _ref2.iframeUrl,
    iframeUrl = _ref2$iframeUrl === void 0 ? null : _ref2$iframeUrl,
    _ref2$provider = _ref2.provider,
    videoProvider = _ref2$provider === void 0 ? null : _ref2$provider,
    videoId = _ref2.id,
    videoWidth = _ref2.width,
    videoHeight = _ref2.height,
    videoDuration = _ref2.duration;
  var lastVideoRef = useRef(media);
  if (lastVideoRef.current === null) {
    lastVideoRef.current = media;
  } else {
    // else if (video !== null && (lastVideoRef.current.type !== video.type || video.live || lastVideoRef.current.live)) {
    lastVideoRef.current = media;
  }
  var _ref3 = lastVideoRef.current || {},
    _ref3$files = _ref3.files,
    files = _ref3$files === void 0 ? null : _ref3$files;
  var _ref4 = files || {},
    _ref4$h = _ref4.h264,
    h264 = _ref4$h === void 0 ? null : _ref4$h,
    _ref4$webm = _ref4.webm,
    webm = _ref4$webm === void 0 ? null : _ref4$webm;
  var _ref5 = h264 || {},
    _ref5$url = _ref5.url,
    h264Url = _ref5$url === void 0 ? null : _ref5$url;
  var _ref6 = webm || {},
    _ref6$url = _ref6.url,
    webmUrl = _ref6$url === void 0 ? null : _ref6$url;
  var finalUrl = h264Url || webmUrl || iframeUrl || url;
  var _useVideo = useVideo(finalUrl, {
      autoplay: autoPlay,
      controls: 0,
      // !withoutControls,
      type: videoProvider,
      videoId: videoId,
      initialMuted: initialMuted,
      width: videoWidth,
      height: videoHeight,
      duration: videoDuration,
      onEnd: onEnd,
      onMetadataChange: onMetadataChange,
      onPlay: onPlay,
      onPause: onPause,
      onBufferStart: onBufferStart,
      onBufferEnded: onBufferEnded,
      onTimeUpdate: onTimeUpdate,
      onVolumeChange: onVolumeChange,
      onLoaded: onLoaded
    }),
    ref = _useVideo.ref,
    api = _objectWithoutProperties(_useVideo, _excluded$1);
  if (apiRef !== null) {
    // console.log('ref update');
    apiRef.current = api;
  }
  var muted = api.muted,
    playing = api.playing,
    buffering = api.buffering,
    loaded = api.loaded;
  var loading = finalUrl !== null && (!loaded || buffering);
  var paused = !playing && !loading && loaded;
  var el = useRef(null);

  // const onTogglePlay = useCallback(() => {
  //     if (playing) {
  //         if (pause !== null) {
  //             pause();
  //         }
  //     } else if (play !== null) {
  //         try {
  //             play();
  //         } catch (err) {
  //             console.log('play blocked', err);
  //         }
  //     }
  // }, [playing, play, pause]);

  // const onSeek = useCallback(
  //     (e) => {
  //         if (seek !== null) {
  //             seek(e);
  //         }
  //         if (play !== null) {
  //             try {
  //                 play();
  //             } catch (err) {
  //                 console.log('play blocked', err);
  //             }
  //         }
  //     },
  //     [seek, play],
  // );

  // console.log(muted, playing, buffering, loaded);

  return /*#__PURE__*/React.createElement("div", {
    ref: el,
    className: classNames([styles.videoContainer, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.paused, paused), styles.loading, loading), styles.muted, muted), styles.isNative, videoProvider === null), className, className !== null)])
  }, url !== null ? /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, videoProvider === 'youtube' || videoProvider === 'vimeo' ? /*#__PURE__*/React.createElement("iframe", {
    key: media !== null ? "video-".concat(finalUrl) : 'video',
    className: classNames([styles.iframe, _defineProperty({}, iframeClassName, iframeClassName !== null)]),
    title: "video",
    frameBorder: 0,
    src: lastVideoRef.current !== null ? lastVideoRef.current.iframeUrl || lastVideoRef.current.url : null,
    ref: ref,
    allow: "autoplay",
    allowFullScreen: true,
    width: width,
    height: height
  }) : null, videoProvider === null ? /*#__PURE__*/React.createElement("video", {
    key: media !== null ? "video-".concat(url) : 'video',
    className: classNames([styles.video, _defineProperty({}, videoClassName, videoClassName !== null)]),
    src: finalUrl,
    type: "video/mp4",
    playsInline: playsInline,
    ref: ref,
    style: {
      width: width,
      height: height
    },
    controls: !withoutControls,
    loop: loop
  }) : null) : null);
};
Video.propTypes = propTypes$1;
Video.defaultProps = defaultProps$1;
var Video$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Video, Object.assign({
    apiRef: ref
  }, props));
});

var _excluded = ["value", "width", "height", "className"];
var propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
    filename: PropTypes.string,
    size: PropTypes.number,
    url: PropTypes.string
  })]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps = {
  value: null,
  width: null,
  height: null,
  className: null
};
var MediaPlayer = function MediaPlayer(_ref) {
  var initialValue = _ref.value,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var value = initialValue || {};
  var _ref2 = value || {},
    type = _ref2.type;
  var apiRef = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, 'border', 'p-2', _defineProperty({}, className, className !== null)]),
    style: {
      width: width,
      height: height
    }
  }, type === 'video' ? /*#__PURE__*/React.createElement(Video$1, Object.assign({
    media: value,
    apiRef: apiRef
  }, props)) : null, type === 'audio' ? /*#__PURE__*/React.createElement(Audio$1, Object.assign({
    media: value,
    apiRef: apiRef
  }, props)) : null);
};
MediaPlayer.propTypes = propTypes;
MediaPlayer.defaultProps = defaultProps;

export { MediaPlayer as default };
